type Props = {
  selectedTab: string;
  setSelectedTab: (value: string) => void;
};

export const SettingsTabbar = (props: Props) => {
  const selectionToggle = (e) => {
    var element = document.getElementsByClassName("selected");
    element[0]?.classList.remove("selected");
    e.target.classList.toggle("selected");
    if (e.target.id === "basic") props.setSelectedTab("basic");
    if (e.target.id === "dns-settings") props.setSelectedTab("dns-settings");
  };
  return (
    <div className="settings-nav">
      <div className="nav-container">
        <div className="nav-container-items">
          <ul className="nav-list">
            <li key="basic" className="nav-item selected" id="basic" onClick={selectionToggle}>
              Basic
            </li>
            <li key="DNS Settings" className="nav-item" id="dns-settings" onClick={selectionToggle}>
              DNS Settings
            </li>
            <li key="Email Settings" className="nav-item" id="email-settings" onClick={selectionToggle}>
              Email Settings
            </li>
            <li key="Advanced" className="nav-item" id="advanced" onClick={selectionToggle}>
              Advanced
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
